import nerisApi from '@/api/neris';

import {
  SET_UNITS,
  SET_UNITS_LOADING,
  SET_INVALIDATE,
} from './mutations';

export const ENSURE_UNITS_LOADED = 'ENSURE_UNITS_LOADED';

export default {
  /**
   * Ensure that units is loaded.
   *
   * @param commit - State commit
   * @param state - Neris state
   */
  [ENSURE_UNITS_LOADED]: async ({ commit, state }) => {
    try {
      if (state.units && !state.invalidate) {
        return;
      }
      commit(SET_UNITS_LOADING, true);
      const result = await nerisApi.getAllUnits();
      commit(SET_UNITS, result.data);
      commit(SET_INVALIDATE, false);
    } finally {
      commit(SET_UNITS_LOADING, false);
    }
  },
};
